module.exports = __webpack_public_path__ + "img/1.ec559607.png";